export const state = {
  kanbanData: [],
}

export const mutations = {
  SET_KANBAN_DATA(state, kanbanData) {
    state.kanbanData = kanbanData
  },
}

export const actions = {
  setKanbanData({ commit }, kanbanData) {
    commit('SET_KANBAN_DATA', kanbanData)
  },
}
